import { render, staticRenderFns } from "./JavneNabavke.vue?vue&type=template&id=466f2a98&"
import script from "./JavneNabavke.vue?vue&type=script&lang=js&"
export * from "./JavneNabavke.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports